import { Component, effect, input, OnInit } from '@angular/core';
import { Vehicle } from 'src/app/models/vehicle.model';
import { VehicleProvider } from 'src/app/services/providers/vehicle-provider/vehicle-provider';

@Component({
  selector: 'app-vehicle-registration-header',
  templateUrl: './vehicle-registration-header.component.html',
  styleUrls: ['./vehicle-registration-header.component.scss'],
  standalone: false,
})
export class VehicleRegistrationHeaderComponent {
  /* Vehicle data used to render registration header information */
  headerData = input<Vehicle | null>(null);

  selectedVehicle: Vehicle | null = null;
  showSelectedVehicle = input<boolean>(true);

  /* Registration number for a non-fleet (hire) vehicle not present in the system */
  hireVehicleRegistration = input<string | null>(null);

  /**
   *
   */
  constructor(private readonly vehicleProvider: VehicleProvider) {
    effect(() => {
      this.selectedVehicle = this.vehicleProvider.readSelectedVehicle();
    })
  }

  get isHireVehicle(): boolean {
    return !!this.hireVehicleRegistration();
  }

  get vehicleDetail() {
    return this.showSelectedVehicle() ? this.selectedVehicle : this.headerData();
  }

}
